import ERROR_MESSAGES from './constants';
import { passwordRegex } from '../../utils/constants';

const validations = {
  firstName: {
    required: {
      value: true,
      message: ERROR_MESSAGES.FIRST_NAME_REQUIRED,
    },
  },
  lastName: {
    required: {
      value: true,
      message: ERROR_MESSAGES.LAST_NAME_REQUIRED,
    },
  },
  email: {
    required: {
      value: true,
      message: ERROR_MESSAGES.EMAIL_REQUIRED,
    },
    email: {
      value: true,
      message: ERROR_MESSAGES.WRONG_EMAIL_FORMAT,
    },
  },
  password: {
    required: {
      value: true,
      message: ERROR_MESSAGES.PASSWORD_REQUIRED,
    },
    strength: {
      value: passwordRegex,
      message: ERROR_MESSAGES.PASSWORD_INVALID,
    },
  },
};
export default validations;
